import { useState, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { Button, Typography } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { getStripeSessionResponse } from '/providers/studio-api'
import StripeDirectDebitForm from './stripe-direct-debit-form.jsx'

import direcDebitLogo from '/assets/images/direct-debit.svg'

const DirectDebitDetails = () => {

  const { apiSource, apiKey, client, refreshClient } = useContext(AppContext)
  const { stripeSessionId } = useParams()
  const [open, setOpen] = useState(false)

  useEffect(() => {

  }, [stripeSessionId])

  const openDirectDebitDialog = () => setOpen(true)

  const checkoutComplete = async (stripeSessionId) => {
    await getStripeSessionResponse({ apiSource, apiKey, stripeSessionId })
    refreshClient()
  }

  return (
    <>
      <div className='flex flex-row w-full ml-20 mt-10 p-20'>
          <div className='flex flex-col gap-5 p-10 items-center'>

            <img src={direcDebitLogo} width={200} />

            <div className='flex flex-col gap-5'>
              {client.stripe_dd_payment_method_id && <Typography variant='h5'>Your direct debit mandate is in place</Typography>}
              {!client.stripe_dd_payment_method_id && <Typography variant='h5'>Please setup your direct debit mandate</Typography>}

              <Button variant='contained' onClick={openDirectDebitDialog}>{client.stripe_dd_payment_method_id ? "Change" : "Setup"} direct debit</Button>
            </div>
          </div>
      </div>

      <StripeDirectDebitForm open={open} setOpen={setOpen} checkoutComplete={checkoutComplete} />
    </>
  )
}

export default DirectDebitDetails
